import { v4 as uuid } from 'uuid'
import { useHistory } from 'react-router-dom'
import { db, timestamp } from '../../../firebase/config'
import { client } from '../../../hooks/Client'
import Location from '../../../hooks/Location'
import { useFirestoreGeneral } from '../../../firebase/useFirestore'
import impactChannels from '../impactInBeeldConfig.js'
import { deriveChannelStatus } from '../../../helpers/impactInBeeld/channelStatus'
import ChannelCard from '../ChannelCard.jsx'
import ChannelConfigScreen from '../config/ChannelConfigScreen.jsx'

/**
 * Kanalen tab: de 7 kanalen met vereisten en status. Aanzetten schrijft een
 * ImpactChannels-doc met Status 'concept' (dedupe-veilig); URL-segment 4 opent
 * het configscherm. See docs/features/impact-in-beeld-fase2.md.
 *
 * @param {object} props
 * @param {ReturnType<typeof import('../../../hooks/useImpactPerEuroRatio').default>} props.impactPerEuro - Kengetal-resultaat, éénmalig opgehaald door de hub
 */
const ChannelsTab = ({ impactPerEuro }) => {
    const history = useHistory()

    // /:client/impactinbeeld/kanalen/:channelId → segment 4 opent het configscherm.
    const configSegment = Location()[4]

    const channelDocs = useFirestoreGeneral('ImpactChannels', 'CompagnyID', client)

    // Vóór de eerste snapshot is niet te zien welke kanalen al aanstaan —
    // aanzetten pas toestaan als de data er is (anders duplicaat-race).
    const channelDocsLoaded = Array.isArray(channelDocs)

    const docForChannel = (channelId) =>
        (channelDocs || []).find((doc) => doc.ChannelId === channelId)

    const enableChannel = (channelId) => {
        // Dedupe guard: never a second doc for the same channel.
        if (!channelDocsLoaded || docForChannel(channelId)) return

        const nextPosition = channelDocs
            .reduce((max, doc) => Math.max(max, Number(doc.Position) || 0), 0) + 1

        db.collection('ImpactChannels').add({
            ID: uuid(),
            CompagnyID: client,
            Compagny: client,
            Position: nextPosition,
            Timestamp: timestamp,
            ChannelId: channelId,
            Status: 'concept',
        })
        .catch((error) => alert(error))
    }

    const configChannel = impactChannels.find((channel) => channel.id === configSegment)
    const configChannelDoc = configChannel && docForChannel(configChannel.id)

    // Configscherm alleen voor een bekend, al aangezet kanaal; anders de lijst.
    // key = kanaal-id: directe navigatie tussen twee config-URL's mag geen
    // state (selectie, publish-status) van het vorige kanaal meenemen.
    if (configChannel && configChannelDoc) {
        return (
            <ChannelConfigScreen
                key={configChannel.id}
                channel={configChannel}
                channelDoc={configChannelDoc}
                impactPerEuro={impactPerEuro}
            />
        )
    }

    return (
        <div className='impact-in-beeld-tab'>
            <h2>Kanalen</h2>
            <p className='impact-in-beeld-tab-intro'>
                Zet een kanaal aan om je impact te tonen op de plekken waar klanten je ontmoeten.
                Per kanaal zie je wat het nodig heeft.
            </p>
            <div className='impact-channel-list'>
                {impactChannels.map((channel) => (
                    <ChannelCard
                        key={channel.id}
                        channel={channel}
                        status={deriveChannelStatus(docForChannel(channel.id))}
                        onEnable={enableChannel}
                        enableDisabled={!channelDocsLoaded}
                        onOpenConfig={(channelId) => history.push(`/${client}/impactinbeeld/kanalen/${channelId}`)}
                    />
                ))}
            </div>
        </div>
    )
}

export default ChannelsTab
